export interface StatesState {
  states: any;
  isResolved: boolean; // check states API is resolved or not
}

export interface StatesRequest {
  country: string;
  userLanguage: string;
}
